import { render } from "./FormRelManyTags.vue?vue&type=template&id=522e216d"
import script from "./FormRelManyTags.vue?vue&type=script&lang=js"
export * from "./FormRelManyTags.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManyTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "522e216d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('522e216d', __exports__)) {
    console.log('reload')
    api.reload('522e216d', __exports__)
  }
  
  module.hot.accept("./FormRelManyTags.vue?vue&type=template&id=522e216d", () => {
    console.log('re-render')
    api.rerender('522e216d', render)
  })

}


export default __exports__